import { useLocation, useNavigate } from "react-router-dom";

export default function ErrorPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const error = location.state?.error || {};
  const message = error.message || "Something went wrong while loading chart data.";
  const code = error.code || "UNKNOWN_ERROR";
  const details = error.details || null;

  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center px-4">
      <div className="max-w-2xl w-full bg-zinc-900/70 border border-zinc-800 rounded-xl p-8 shadow-xl">
        <div className="flex items-center gap-3 mb-4">
          <div className="h-10 w-10 rounded-full bg-red-500/15 border border-red-500/30 flex items-center justify-center">
            <span className="text-red-400 font-bold">!</span>
          </div>
          <div>
            <h1 className="text-2xl font-semibold text-zinc-100">Chart Data Error</h1>
            <p className="text-zinc-400 text-sm">We could not fetch data to generate the chart.</p>
          </div>
        </div>

        <div className="bg-zinc-950/70 border border-zinc-800 rounded-lg p-4 mb-4">
          <p className="text-xs uppercase tracking-wide text-zinc-500">Error Code</p>
          <p className="text-sm text-zinc-100 mt-1 font-mono">{code}</p>
          <p className="text-xs uppercase tracking-wide text-zinc-500 mt-4">Message</p>
          <p className="text-sm text-zinc-300 mt-1">{message}</p>
        </div>

        {details && (
          <div className="bg-zinc-950/70 border border-zinc-800 rounded-lg p-4 mb-6">
            <p className="text-xs uppercase tracking-wide text-zinc-500">Details</p>
            <pre className="text-xs text-zinc-400 mt-2 whitespace-pre-wrap">
              {JSON.stringify(details, null, 2)}
            </pre>
          </div>
        )}

        <div className="flex flex-wrap gap-3">
          <button
            onClick={() => navigate(-1)}
            className="px-4 py-2 rounded-md bg-zinc-800 text-zinc-100 hover:bg-zinc-700 transition-colors"
          >
            Go Back
          </button>
          <button
            onClick={() => navigate("/")}
            className="px-4 py-2 rounded-md bg-amber-500 text-zinc-900 hover:bg-amber-400 transition-colors"
          >
            Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
